import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type DirectContactFormSubmitStatus } from '../../hooks/useDirectContactFormSubmit'

import { useDirectContactFormHookFormDialogAuthentication } from './DirectContactFormHookFormDialogContext'
import { DirectContactFormHookFormDialogSubmitFields } from './DirectContactFormHookFormDialogSubmitFields'
import {
  DirectContactFormHookFormFields,
  type DirectContactFormHookFormFieldsProps,
} from './DirectContactFormHookFormFields'

type DirectContactFormHookFormDialogFormContentProps = {
  configuration: DirectContactFormHookFormFieldsProps['configuration']
  isMutating: boolean
  submitStatus: DirectContactFormSubmitStatus
}

export const DirectContactFormHookFormDialogFormContent: FC<
  DirectContactFormHookFormDialogFormContentProps
> = ({ configuration, isMutating, submitStatus }) => {
  const { isCustomerDataComplete, isLoggedIn } =
    useDirectContactFormHookFormDialogAuthentication()

  return (
    <>
      <p className="text-xs text-dark-primary-strong">
        <FormattedMessage id="general.form.label.mandatoryFieldIndicator" />
      </p>
      <DirectContactFormHookFormFields
        authentication={{ isCustomerDataComplete, isLoggedIn }}
        configuration={configuration}
      />
      <DirectContactFormHookFormDialogSubmitFields
        isMutating={isMutating}
        resolvedSubject={configuration.resolvedSubject}
        submitStatus={submitStatus}
      />
    </>
  )
}
